import { jsxs as $, jsx as i } from "react/jsx-runtime";
import { c as _ } from "./index-65016bfa.mjs";
import s, { css as a } from "styled-components";
import "@fcamna/shared-component-foundations";
import g, { useRef as z, useState as Q, useEffect as X } from "react";
import { u as S } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Icon as J } from "./icon.js";
import { L as U } from "./label-33699561.mjs";
import { u as Y } from "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import { u as v } from "./uniqueId-321287e8.mjs";
import { I, H as Z } from "./helperText-d9646f54.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "@fcamna/shared-icons";
import "./popupTip.js";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./button.js";
import "./closeButton.js";
import "./iconButton.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
const k = {
  UNCHECKED: 0,
  INTERMEDIATE: 1,
  CHECKED: 2
}, P = s.div`
  &.CheckBox-wrapper {
    ${({
  theme: {
    components: { checkbox: e }
  }
}) => a(e.Wrapper)};
  }
`, V = s.label`
  &.CheckBox__label {
    ${({
  theme: {
    components: { checkbox: e }
  }
}) => a(e.Label)};
  }
`, ee = s.span`
  &.Checkbox__input-wrapper {
    ${({
  theme: {
    components: { checkbox: e }
  }
}) => a(e.CheckBoxInputWrapper)};
  }
`, oe = s.input`
  &.CheckBox {
    ${({
  theme: {
    components: { checkbox: e }
  }
}) => a(e.CheckboxInput)};
  }
`, te = s.span`
  &.CheckBox__checkmark-container {
    ${({
  theme: {
    components: { checkbox: e }
  }
}) => a(e.CheckmarkContainer)};
  }
`, re = s(U)`
  &.CheckBox__label-container {
    ${({
  theme: {
    components: { checkbox: e }
  }
}) => a(e.LabelContainer)};
  }
`, ce = s.span`
  &.CheckBox__helper-text {
    ${({
  theme: {
    components: { checkbox: e }
  }
}) => a(e.HelperText)};
  }
`, Ue = ({
  isDisabled: e = !1,
  checkboxValue: c = k.UNCHECKED,
  error: m = !1,
  helperText: h,
  label: f,
  value: R,
  onChange: u,
  isIntermediate: b,
  id: l,
  size: t = "small",
  infoText: E,
  required: D,
  ...B
}) => {
  const G = S({ label: "Checkbox" }), d = Y("checkbox", {
    ariaDisabled: e,
    ariaInvalid: m,
    ariaLabel: f
  }), C = l || v("checkbox_"), x = (n) => {
    b ? (c++, c = c % 3) : c = c === k.UNCHECKED ? k.CHECKED : k.UNCHECKED, u == null || u(n, c);
  }, p = (n) => {
    (n.key === "Enter" || n.key === " ") && (n.preventDefault(), x(n));
  }, y = b && c === k.INTERMEDIATE;
  return /* @__PURE__ */ $(
    P,
    {
      className: _(["CheckBox-wrapper", `CheckBox-wrapper--${t}`]),
      ...G,
      children: [
        /* @__PURE__ */ $(V, { className: _(["CheckBox__label", { "CheckBox__label--disabled": e }]), children: [
          /* @__PURE__ */ $(ee, { className: "Checkbox__input-wrapper", children: [
            /* @__PURE__ */ i(
              oe,
              {
                id: C,
                type: "checkbox",
                "aria-label": "checkbox",
                "aria-describedby": h ? `${C}-helper-text` : void 0,
                checked: c > 0,
                disabled: e,
                value: R,
                onChange: x,
                className: _(["CheckBox", { "CheckBox--error": m }]),
                onKeyDown: p,
                required: D,
                ...d,
                ...B
              }
            ),
            c !== k.UNCHECKED && /* @__PURE__ */ i(
              te,
              {
                className: _([
                  "CheckBox__checkmark-container",
                  {
                    "CheckBox__checkmark-container--disabled": e,
                    "CheckBox__checkmark-container--error": m
                  }
                ]),
                children: /* @__PURE__ */ i(J, { name: y ? "subtract" : "checkmark" })
              }
            )
          ] }),
          f && /* @__PURE__ */ i(
            re,
            {
              labelProp: { label: f, htmlFor: C },
              className: "CheckBox__label-container",
              ...E && {
                infoProp: {
                  infoText: E,
                  infoType: "tooltip"
                }
              }
            }
          )
        ] }),
        h && /* @__PURE__ */ i(
          ce,
          {
            id: `${C}-helper-text`,
            className: _([
              "CheckBox__helper-text",
              {
                "CheckBox__helper-text--disabled": e
              }
            ]),
            children: h
          }
        )
      ]
    }
  );
}, se = s.fieldset`
  &.CheckboxGroup__fieldset {
    ${({
  theme: {
    components: { checkbox: e }
  }
}) => a(e.CheckBoxGroupFieldSet)};
  }
`, ae = s.div`
  &.CheckboxGroup {
    ${({
  theme: {
    components: { checkbox: e }
  }
}) => a(e.CheckboxGroup)};
  }
`, pe = v(), q = "CheckboxGroup", Oe = ({
  onChange: e,
  title: c,
  children: m,
  isIntermediate: h = !1,
  helperText: f,
  error: R,
  isHorizontal: u = !1,
  size: b = "small",
  helperTextProp: l,
  labelProps: t,
  inputState: E
}) => {
  var H, w;
  const D = S({ label: "Checkbox Group" }), B = z(v(q)), G = `${B.current}_label_id`, [d, C] = Q([]);
  let x = l, p = E || I.NONE;
  E || (p = R ? I.ERROR : I.NONE), l ? x = {
    ...l,
    secondaryProp: {
      ...l.secondaryProp,
      state: p
    }
  } : x = {
    [p === I.ERROR ? "secondaryProp" : "defaultProp"]: {
      helperText: f,
      id: `${p === I.ERROR ? "invalid" : "valid"}_${q}_helperText`,
      state: p
    }
  }, X(() => {
    C(
      m.map((o, r) => {
        var N;
        return {
          value: (o == null ? void 0 : o.props.checkboxValue) || ((N = d[r]) == null ? void 0 : N.value) || k.UNCHECKED,
          isIntermediate: o.props.isIntermediate !== void 0 ? o.props.isIntermediate : h || !1
        };
      })
    );
  }, [h, m]);
  const y = (o) => {
    const r = [...d];
    o >= d.length || (r[o].value += 1, r[o].value = r[o].isIntermediate ? r[o].value % 3 : r[o].value % 2, C(r));
  }, n = () => m.map((o, r) => {
    var K;
    const N = r + 1, O = o.props.isDisabled, A = o.props.isIntermediate !== void 0 ? o.props.isIntermediate : h || !1, M = o.props.checkboxValue || ((K = d[r]) == null ? void 0 : K.value), W = o.props.error === !1 ? !1 : p === "error";
    return g.cloneElement(o, {
      key: r,
      checkboxValue: M,
      isDisabled: O,
      error: W,
      size: o.props.size || b,
      onChange(L, j) {
        var F, T;
        (T = (F = o.props).onChange) == null || T.call(F, L, j), e == null || e(L), y(r);
      },
      isIntermediate: A,
      id: o.props.id ?? `FPDSCheckboxComponent${N}-${pe}`
    });
  });
  return /* @__PURE__ */ $(
    se,
    {
      className: "CheckboxGroup__fieldset",
      ...D,
      children: [
        /* @__PURE__ */ i(
          U,
          {
            className: "CheckboxGroup__legend",
            renderAs: "legend",
            labelProp: {
              id: G,
              htmlFor: B.current,
              label: ((H = t == null ? void 0 : t.labelProp) == null ? void 0 : H.label) ?? c,
              showRequiredIndicator: ((w = t == null ? void 0 : t.labelProp) == null ? void 0 : w.showRequiredIndicator) ?? !1
            },
            infoProp: t == null ? void 0 : t.infoProp,
            trailingText: t == null ? void 0 : t.trailingText
          }
        ),
        /* @__PURE__ */ i(
          ae,
          {
            className: _([
              "CheckboxGroup",
              `CheckboxGroup--${b}`,
              {
                "CheckboxGroup--horizontal": u,
                "CheckboxGroup--vertical": !u
              }
            ]),
            children: n()
          }
        ),
        /* @__PURE__ */ i(Z, { ...x })
      ]
    }
  );
};
export {
  Ue as Checkbox,
  Oe as CheckboxList,
  k as CheckboxStateValues
};
